import { Currency } from 'common/utils/currency';

export type BundleOptionKey =
    | 'logo-design'
    | 'logo-business-card-design'
    | 'logo-web-bundle'
    | 'brand-identity-pack';

export interface BundleContent {
    key: BundleOptionKey;
    savingsText?: string; // TODO: remove this and pick it up from `start` Rails backend.
    title: string;
    image?: {
        src: string;
        designer?: string;
    };
}

export interface BundlePrice {
    key: BundleOptionKey;
    currency: Currency;
    amountInCents: number;
    savingsInCents: number;
    savingsText?: string;
}

export type BundleOption = BundlePrice & BundleContent;

export const bundlesContent: BundleContent[] = [
    {
        key: 'logo-design',
        title: 'No thanks, just my logo',
    },
    {
        key: 'logo-business-card-design',
        title: 'Bundle with a business card',
        image: {
            src: 'images/interactive/business_card-IRDESIGN.jpg',
            designer: 'IRDESIGN',
        },
    },
    {
        key: 'brand-identity-pack',
        savingsText: 'Save 39%+', // TODO: remove this and pick it up from `start` Rails backend.
        title: 'Bundle with a brand identity pack',
        image: {
            src: 'images/interactive/brand_identity_pack-Sevarika.jpg',
            designer: 'Sevarika™',
        },
    },
    {
        key: 'logo-web-bundle',
        title: 'Bundle with a website',
        image: {
            src: 'images/interactive/website-Armin_Braunsberger.jpg',
            designer: 'Armin Braunsberger',
        },
    },
];
